import { defineNuxtPlugin } from '#app/nuxt'
import { LazyBlockCard, LazyCard, LazyFeatureCard, LazyGeneralCard, LazyImageCard, LazyProductCard, LazyAllJobPositions, LazyAllLearnMoreArticles, LazyAllNewsArticles, LazyAllTrainingArticle, LazyArticle, LazyCarousel3d, LazyJobPosition, LazyNewsArticle, LazyOpportunityDay, LazyReferences, LazySubHeroArticles, LazyTrainingArticle, LazyFullGrid, LazyGrid, LazyHeader, LazyPage, LazyAppLink, LazyBanner, LazyBlock, LazyButton, LazyCallToAction, LazyCarouselCard, LazyHeroMultipleSlide, LazyHeroSlide, LazyInfiniteCarousel, LazyInfiniteCarousel2, LazyContactForm, LazyFeedbackForm, LazyQuestionForm, LazyWhistleblowingForm, LazyImageBox, LazyList, LazyMainHero, LazyMainHero2, LazyMap, LazyAccordion, LazyModal, LazyPopup, LazyRBI, LazyTrustedLogo, LazyTable, LazyTable2, LazyTheHeader, LazyTheImage, LazyTheMedia, LazyVideo, LazyYoutubeEmbed2, LazyYoutubeEmbed } from '#components'
const lazyGlobalComponents = [
  ["BlockCard", LazyBlockCard],
["Card", LazyCard],
["FeatureCard", LazyFeatureCard],
["GeneralCard", LazyGeneralCard],
["ImageCard", LazyImageCard],
["ProductCard", LazyProductCard],
["AllJobPositions", LazyAllJobPositions],
["AllLearnMoreArticles", LazyAllLearnMoreArticles],
["AllNewsArticles", LazyAllNewsArticles],
["AllTrainingArticle", LazyAllTrainingArticle],
["Article", LazyArticle],
["Carousel3d", LazyCarousel3d],
["JobPosition", LazyJobPosition],
["NewsArticle", LazyNewsArticle],
["OpportunityDay", LazyOpportunityDay],
["References", LazyReferences],
["SubHeroArticles", LazySubHeroArticles],
["TrainingArticle", LazyTrainingArticle],
["FullGrid", LazyFullGrid],
["Grid", LazyGrid],
["Header", LazyHeader],
["Page", LazyPage],
["AppLink", LazyAppLink],
["Banner", LazyBanner],
["Block", LazyBlock],
["Button", LazyButton],
["CallToAction", LazyCallToAction],
["CarouselCard", LazyCarouselCard],
["HeroMultipleSlide", LazyHeroMultipleSlide],
["HeroSlide", LazyHeroSlide],
["InfiniteCarousel", LazyInfiniteCarousel],
["InfiniteCarousel2", LazyInfiniteCarousel2],
["ContactForm", LazyContactForm],
["FeedbackForm", LazyFeedbackForm],
["QuestionForm", LazyQuestionForm],
["WhistleblowingForm", LazyWhistleblowingForm],
["ImageBox", LazyImageBox],
["List", LazyList],
["MainHero", LazyMainHero],
["MainHero2", LazyMainHero2],
["Map", LazyMap],
["Accordion", LazyAccordion],
["Modal", LazyModal],
["Popup", LazyPopup],
["RBI", LazyRBI],
["TrustedLogo", LazyTrustedLogo],
["Table", LazyTable],
["Table2", LazyTable2],
["TheHeader", LazyTheHeader],
["TheImage", LazyTheImage],
["TheMedia", LazyTheMedia],
["Video", LazyVideo],
["YoutubeEmbed2", LazyYoutubeEmbed2],
["YoutubeEmbed", LazyYoutubeEmbed],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
